import React from "react";
import {LangItem} from "../core/Helpers/LangItem";

type PrivacyPolicyComponentProps = {
};

class PrivacyPolicyComponent extends React.Component<PrivacyPolicyComponentProps> {

    constructor(props: PrivacyPolicyComponentProps) {
        super(props);
    }

    render() {
        return (
            <div className={'main-privacy-text'}>
               <div className={'flex-center'}>
                   <div className='main-privacy-text-title'>
                       <LangItem for={'Privacy Policy'}/>
                   </div>
                   <div className='main-privacy-text-description'>
                       <LangItem for={'Chobal Classic Restoration respects your privacy. This Privacy Policy outlines how we may collect, use, and protect any information you provide when using this website.'}/>
                   </div>
               </div>
                <div className="flex-center">
                    <div className="main-privacy-text-title mb-4">
                        <LangItem for={'Information we may collect:'}/>
                    </div>

                    <ul className="">
                        <li className="main-privacy-text-description">
                            <LangItem for={'Name, email address, or phone number (if you contact us through the website).'}/>
                        </li>
                        <li className="main-privacy-text-description">
                            <LangItem for={'Any other information you voluntarily submit through forms.'}/>
                        </li>
                    </ul>
                </div>
                <div className="flex-center">
                    <div className="main-privacy-text-title mb-4">
                        <LangItem for={'How we use this information:'}/>
                    </div>

                    <ul className="">
                        <li className="main-privacy-text-description">
                            <LangItem for={'To respond to your inquiries.'}/>
                        </li>
                        <li className="main-privacy-text-description">
                            <LangItem for={'To improve our services and customer experience.'}/>
                        </li>
                    </ul>
                </div>
                <div className={'flex-center'}>
                    <div className='main-privacy-text-title'>
                        <LangItem for={'Cookies and analytics:'}/>
                    </div>
                    <div className='main-privacy-text-description'>
                        <LangItem for={'We currently do not use cookies or analytics tools. If this changes, the policy will be updated accordingly.'}/>
                    </div>
                </div>
                <div className={'flex-center'}>
                    <div className='main-privacy-text-title'>
                        <LangItem for={'Data security:'}/>
                    </div>
                    <div className='main-privacy-text-description'>
                        <LangItem for={'We are committed to keeping your information secure and confidential. We do not sell, distribute or lease your personal information to third parties.'}/>
                    </div>
                </div>
                <div className={'flex-center'}>
                    <div className='main-privacy-text-title'>
                        <LangItem for={'Your rights:'}/>
                    </div>
                    <div className='main-privacy-text-description'>
                        <LangItem for={'You may request details about the information we hold about you, or ask us to delete your data, by contacting us directly.'}/>
                    </div>
                </div>
                <div className={'flex-center'}>
                    <div className='main-privacy-text-title'>
                        <LangItem for={'Contact:'}/>
                    </div>
                    <div className='main-privacy-text-description'>
                        <LangItem for={'If you have any questions, please email us at'}/>
                            <a href="mailto:chobalrestoration@gmail.com" className={'td-none'}><b>{' '}chobalrestoration@gmail.com</b></a>
                    </div>
                </div>
            </div>
        );
    }
}

export {PrivacyPolicyComponent};
